<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>

<app-full-screen-image
  [imageSrc]="(fullscreenService.imageSource$ | async) || ''"
  [isOpen]="(fullscreenService.isOpen$ | async) || false"
  (close)="fullscreenService.closeFullscreen()"
>
</app-full-screen-image>
